// src/pages/reporting/NewPatients.jsx
import { Card } from "@common";
import { CreatePatientForm } from "@common";
import PatientPreviousReports from "./PatientPreviousReports";

export default function NewPatients({ clinicId, canEdit = true }) {
  return (
    <>
      {/* ---------- PATIENT INFORMATION FORM ---------- */}
      <Card className="mt-4">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-bold">Patient Information Form</h2>
        </div>

        <CreatePatientForm clinicId={clinicId} canEdit={canEdit} />
      </Card>

      {/* ---------- PREVIOUS REPORTS ---------- */}
      <div className="mt-8">
        <PatientPreviousReports clinicId={clinicId} />
      </div>
    </>
  );
}
